import CustomBadge from './CustomBadge'
export default CustomBadge
export * from './CustomBadge'
